import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
//Hooks
import useLoading from "../../../../hooks/useLoading";
import apiRequest from "../../../../hooks/apiRequest";
//Components
import LayoutModal from "../../../LayoutModal";
import CreditCardPay from "../../Payment/CreditCard";
import Loading from "../../../../components/Loading";
//Inteface
import { Inputs } from "Interfaces/IPayCredit";
import { IMethPay } from "Interfaces/IMethodPaym";
//Icons
import { X, Check, CalendarBlank, CreditCard } from "@phosphor-icons/react";
//utils
import FormatarData from "utils/FormatData";
import { CurrencyFormat } from "utils/CurrencyFormat";


interface ICreate {
  isOpenModalCustomer: boolean;
  setModalClose: () => void;
  selectedId: number | null;
  setToastOpen: (value: boolean) => void;
  setToastData: (data: { status: number; message: string }) => void;
}

interface IPaymentsSubmit {
  payments: IPayments[],
}

interface IPayments {
  name: string,
  payment_method_id: number,
  amount: number | null,
  installment_on_credit_card_id?: number | null;
}

interface InstallmentData {
  amount: string,
  created_at: string,
  due_date: string,
  id: number,
  installment: number
  item_payment_id: number
  status: string,
  updated_at: string

  combined_payments: ICombinedPayments[],
}

interface ICombinedPayments {
  amount: string
  id: 29
  installment_on_credit_card_id: null
  payment_method_id: 1
}

export default function PayInvoice({
  isOpenModalCustomer,
  setModalClose,
  selectedId,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    reset,
    resetField,
    handleSubmit: handleFormSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const {
    isLoading: isLoadingSubmit,
    startLoading: startLoadingSubmit,
    stopLoading: stopLoadingSubmit
  } = useLoading();
  const [formPay, setFormPay] = useState<IMethPay[]>([]);
  const [paymentsList, setPaymentsList] = useState<IPaymentsSubmit>({
    payments: []
  })
  const [data, setData] = useState<InstallmentData | null>();

  const fetchData = async () => {
    startLoading();
    try {
      const [response, responsePay] = await Promise.all([
        axiosInstance.get(`installment/${selectedId}`),
        axiosInstance.get(`payment-method`),
      ])
      setData(response.data);
      const paymentData = responsePay.data;
      const FilterPayment = paymentData.filter(
        (payment: IMethPay) =>
          payment.payment_method !== "Crediário da Loja"
      );
      console.log('response:', response);
      setFormPay(FilterPayment);
    } catch (error) {
      console.error("Erro ao obter dados:", error);
    }
    finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (selectedId && isOpenModalCustomer) {
      fetchData();
    }
  }, [selectedId, isOpenModalCustomer]);

  //Cadastrar
  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoadingSubmit();
    try {
      const payload = {
        status: "Pago",
        ...paymentsList
      };
      const response = await apiRequest<Inputs>(
        `installment/${selectedId}`,
        "PATCH",
        payload
      );
      if (response.status === 200) {
        setToastData({
          status: response.status,
          message: 'Pagamento realizado com sucesso! Atualize a página para ver as mudanças',
        });

        setToastOpen(true);
        onClose();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoadingSubmit();
    }
  };

  //FECHAR MODAL
  const onClose = () => {
    setModalClose();
    setPaymentsList({
      payments: []
    });
    reset();
  };

  //FUNÇÃO DE ADICIONAR PAGAMENTO
  const handlePayment = (id: number, name: string) => {
    console.log(`id: ${id}, name: ${name}`);
    let updatedPayments: IPayments[] = [];

    // Adiciona pagamento
    updatedPayments = [
      ...paymentsList.payments,
      {
        name: name,
        payment_method_id: id,
        amount: null,
        installment_on_credit_card_id: null
      }
    ];

    setPaymentsList(prev => ({
      ...prev,
      payments: updatedPayments
    }))
  }

  // Função para REMOVER UM PAGAMENTO específico
  const handleRemovePayment = (index: any) => {
    const updatedPayments = paymentsList.payments.filter((_, i) => i !== index);

    setPaymentsList(prev => ({
      ...prev,
      payments: updatedPayments
    }));
  };

  const getPayments = (id: number) => {
    const payment = formPay.find((pay) => pay.id === id);
    console.log('resposta: ', payment);
    return payment?.payment_method || '-'
  }

  if (isOpenModalCustomer) {
    return (
      <LayoutModal
        statusLoad={isLoadingSubmit}
        title="Pagar Fatura"
        subTitle="Informe o valor e a forma de pagamento da fatura."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Pagar"
      >
        {isLoading || !data ? (
          <Loading />
        ) : (
          <S.Container>
            {
              data.status === 'Pago' ?
                <S.Body>
                  <S.Header>
                    <S.Status className="status-30">
                      <Check size={32} />
                    </S.Status>
                    <S.Title>
                      {CurrencyFormat(parseFloat(data.amount || '0'))}
                    </S.Title>
                    <S.Status>
                      <Check size={16} />
                      <S.Text className="text-p">Pagamento Aprovado</S.Text>
                    </S.Status>
                  </S.Header>

                  <S.Section>
                    <S.ContentInfor>
                      <S.Infor>
                        <CalendarBlank size={16} />
                        <S.Text className="text-p">Data do Pagamento</S.Text>
                      </S.Infor>

                      <S.Infor>
                        <span>
                          <S.Text className="text-p">{FormatarData(data.updated_at)}</S.Text>
                        </span>
                      </S.Infor>
                    </S.ContentInfor>

                    <S.ContentInfor>
                      <S.Infor>
                        <CreditCard size={16} />
                        <S.Text className="text-p">Forma de Pagamento</S.Text>
                      </S.Infor>

                      <S.Section>
                        {
                          data.combined_payments.map((pay) =>
                            <S.Infor>
                              <span>
                                <S.Text className="text-p">
                                  {getPayments(pay.payment_method_id)}: {CurrencyFormat(parseFloat(pay.amount || '0'))}
                                </S.Text>
                              </span>
                            </S.Infor>
                          )
                        }
                      </S.Section>
                    </S.ContentInfor>

                    <S.ContentInfor>
                      <S.Infor>
                        <S.Text className="text-p">Status</S.Text>
                      </S.Infor>

                      <S.Status>
                        <Check size={16} />
                        <S.Text className="text-p">{data.status}</S.Text>
                      </S.Status>
                    </S.ContentInfor>
                  </S.Section>
                </S.Body>
                :
                <S.Body>
                  <S.Header>
                    <S.Title>
                      <span>Total da Parcela</span>
                      {CurrencyFormat(parseFloat(data.amount || '0'))}
                    </S.Title>
                  </S.Header>
                  {/* PAYMENTS Options section */}
                  <S.Section>
                    <S.FormInput>
                      <S.Label>
                        Forma de Pagamento
                        <span>*</span>
                      </S.Label>

                      <S.listButtonPay className="grid">
                        {formPay.map((option) => (
                          <S.ContentPayment key={`${option.id}-${option.payment_method}`}>
                            <S.ButtonPayment
                              onClick={() => handlePayment(
                                option.id,
                                option.payment_method,
                              )}
                              className={
                                paymentsList.payments.some(p => p.name === option.payment_method)
                                  ? "active"
                                  : ""
                              }
                            >
                              {option.payment_method || '-'}
                            </S.ButtonPayment>
                          </S.ContentPayment>
                        ))}
                      </S.listButtonPay>
                    </S.FormInput>
                  </S.Section>

                  {/* VALUES distribution section */}
                  <S.Section>
                    <S.Label>
                      Distribuição de Valores
                      <span>*</span>
                    </S.Label>

                    {paymentsList.payments.map((payment, index) => (
                      <S.ContentPayment
                        className="content-color"
                        key={index}
                      >
                        <S.HeaderValues>
                          <S.Label className="subtitle-full">
                            Valor do {payment.name || 'Forma de pagamento'}
                          </S.Label>
                          <S.ButtonClose
                            onClick={() => handleRemovePayment(index)}
                          >
                            <X size={16} />
                          </S.ButtonClose>
                        </S.HeaderValues>

                        <S.ContentInput>
                          <NumericFormat
                            prefix="R$ "
                            decimalSeparator=","
                            decimalScale={2}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            placeholder="R$ 0,00"
                            value={payment.amount ?? ''}
                            onValueChange={(values) => {
                              const value = values.floatValue ?? 0;

                              setPaymentsList(prev => {
                                const updated = [...prev.payments];
                                updated[index] = {
                                  ...updated[index],
                                  amount: value
                                };
                                return { ...prev, payments: updated };
                              });
                            }}
                          />
                        </S.ContentInput>

                        {
                          payment.name === "Cartão de Crédito" && (
                            <CreditCardPay
                              register={register}
                              errors={errors}
                              reset={reset}
                              resetField={resetField}
                              subtotal={payment.amount || 0}
                              index={index}
                              responsaData={(
                                id
                              ) => setPaymentsList(prev => {
                                const updated = [...prev.payments];
                                const current = updated[index];

                                updated[index] = {
                                  ...current,
                                  installment_on_credit_card_id: id,
                                };

                                return { ...prev, payments: updated };
                              })}
                            />
                          )}
                      </S.ContentPayment>
                    ))}
                  </S.Section>
                </S.Body>
            }
          </S.Container>
        )}
      </LayoutModal>
    );
  }
  return null;
}
